import parseQueryStrings from "@crehana/utils/dist/parseQueryStrings";

import transformData from "Jsx/Utils/transformData";
import getBaseInitialState from "Jsx/Utils/getBaseInitialState";
import { blogCategories } from "./constants";

export const getInitialState = getBaseInitialState((data) => ({
  resource: {
    // @ts-expect-error
    ...data.resource,
    // @ts-expect-error
    coverImages: transformData(data.resource.resourceimageSet) || [],
  },
  blogCategories,
}));

const itemTypes: { [key: string]: "tool" | "ebook" | "tutorial" } = {
  herramientas: "tool",
  ebooks: "ebook",
  tutoriales: "tutorial",
};

export const getResourceItemType = (category?: string) =>
  itemTypes[category || "herramientas"];

export const getNextUrl = (): string => {
  const nextParam = parseQueryStrings(window.location.search)?.next;
  const nextUrl = typeof nextParam === "string" ? nextParam : "";

  return nextUrl;
};

export const redirectWithQueryParams = (url: string) => {
  const queryParams = window.location.search;
  const nextUrl = getNextUrl();

  /**
   * We need to remove the `next` query param if it contains /registro-extra/
   * when we change to /entrar/ so we don't trigger the onboarding after login,
   * all of this avoiding loosing other query params like utms
   */
  if (url === "/entrar/" && nextUrl.includes("registro-extra")) {
    const qs = parseQueryStrings(window.location.search);

    if (qs) {
      delete qs.next;

      const search = Object.keys(qs).reduce(
        (acc, key) => `${acc}${acc ? "&" : ""}${key}=${qs[key]}`,
        ""
      );

      window.location.href = `${url}${search ? `?${search}` : ""}`;
      return;
    }
  }

  window.location.href = `${url}${queryParams}`;
};
